import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useState, useEffect } from "react";

interface RejectRequestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSubmitting: boolean;
  onConfirm: (notes: string) => void;
}

/**
 * Organism: Dialog for rejecting a request with notes
 */
export function RejectRequestDialog({
  open,
  onOpenChange,
  isSubmitting,
  onConfirm,
}: RejectRequestDialogProps) {
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) {
      setNotes("");
      setError("");
    }
  }, [open]);

  const handleConfirm = () => {
    if (!notes.trim()) {
      setError("Las notas de observación son obligatorias");
      return;
    }

    if (notes.length > 500) {
      setError("Las notas no pueden exceder 500 caracteres");
      return;
    }

    setError("");
    onConfirm(notes);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Marcar Solicitud como Observada</DialogTitle>
          <DialogDescription>
            Por favor, indique las razones de la observación. Esta información será visible para el solicitante.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label htmlFor="observation-notes" className="text-sm font-medium">
              Notas de Observación *
            </label>
            <Textarea
              id="rejection-notes"
              placeholder="Explique las razones de la observación..."
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
                setError("");
              }}
              className={error ? "border-red-500" : ""}
              rows={5}
              maxLength={500}
              disabled={isSubmitting}
            />
            <div className="flex justify-between text-sm">
              <span className="text-red-500">{error}</span>
              <span className="text-gray-500">
                {notes.length}/500 caracteres
              </span>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isSubmitting || !notes.trim()}
          >
            {isSubmitting ? "Marcando como observado..." : "Observar Solicitud"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
